import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Icon from '../../Icon';
import { ChannelPickerItem } from '../types/ChannelPicker';
import { post } from '../../../Services/http';

const RegionHeaderDropdown = ({
  options,
  selectedOption,
}: {
  selectedOption: ChannelPickerItem;
  options: ChannelPickerItem[];
}) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const onChannelPickerUpdate = async (cultureCode: string) => {
    try {
      const response = await post(
        `/api/channelpicker?cultureCode=${cultureCode}`,
        {}
      );
      if (response.ok) {
        window.location.reload();
      }
    } catch (error) {
      console.log(
        'An error occured when changing language in the channel picker'
      );
    }
  };

  useEffect(() => {
    const onOutsideClick = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', onOutsideClick);
    return () => {
      document.removeEventListener('click', onOutsideClick);
    };
  }, []);

  return options ? (
    <div
      className={clsx('relative hidden w-full cursor-pointer lg:block')}
      tabIndex={2}
      ref={dropdownRef}
    >
      <div
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="flex items-center gap-0.5 text-topBarText"
      >
        <Icon
          name={`flag-` + selectedOption?.region.toLowerCase()}
          className="mr-1.5 overflow-hidden rounded-full"
        />
        {selectedOption?.displayName}
        <Icon
          name="caret-down"
          className={clsx(
            dropdownOpen && 'rotate-180',
            'transition-transform'
          )}
        />
      </div>
      {dropdownOpen && (
        <ul className="absolute right-0 top-full z-10 mt-2 min-w-full whitespace-nowrap border border-solid border-black bg-gray-800 text-white">
          {options?.map((option) => (
            <li
              className="flex items-center gap-2 bg-gray-800 p-1.5 px-2 text-md hover:bg-gray-700"
              key={option.region}
            >
              <Icon
                name={`flag-` + option.region.toLowerCase()}
                className="overflow-hidden rounded-full"
              />
              {!option.cultureName && option.url && (
                <a href={option.url}>{option.displayName}</a>
              )}
              {option.cultureName && (
                <button
                  onClick={() =>
                    onChannelPickerUpdate(option.cultureName!)
                  }
                >
                  {option.displayName}
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  ) : null;
};

export default RegionHeaderDropdown;
